var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"StoresManager"}},[_c('appHeader'),_c('router-view',{staticClass:"content-body-hasFooter"}),_c('appSmFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }